<template>
  <div class="content">
    <div class="row mt-0" v-if="!showRecFacial">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left">
            Lista de Funcionários
          </h4>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div>
                <el-select
                  class="select-success mb-3 pagination-select"
                  v-model="pagination.perPage"
                  placeholder="Per page"
                >
                  <el-option
                    class="select-success"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </div>
              <div
                class="d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <div>
                  <base-input>
                    <el-input
                      :ref="'focusMe'"
                      type="search"
                      class="mb-3 search-input"
                      color="success"
                      clearable
                      prefix-icon="el-icon-search"
                      placeholder="Pesquisar funcionário"
                      v-model="searchQuery"
                      aria-controls="datatables"
                    >
                    </el-input>
                  </base-input>
                </div>
              </div>
            </div>

            <el-table :data="queriedData" @row-click="handleRecFacial">
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              >
              </el-table-column>
              <el-table-column :min-width="135" align="right" label="Ações">
                <div slot-scope="props">
                  <el-tooltip
                    content="Registrar Ponto"
                    effect="light"
                    :open-delay="300"
                    placement="top"
                  >
                    <base-button
                      class="edit btn-link"
                      type="info"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-camera-18"></i>
                    </base-button>
                  </el-tooltip>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                Mostrando de {{ from + 1 }} a {{ to }} no total de
                {{ total }} funcionários.
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <div v-else>
      <div class="row">
        <div class="col-md-6 mr-auto">
          <card class="card-register card-white">
            <div class="row" style="margin-top: 10px;">
              <div class="col-md-12 text-left">
                <h4 slot="header" class="card-title text-uppercase">
                  {{ selectRow.nome }}
                </h4>

                <img
                  class="d-none d-lg-block d-xl-block"
                  :src="'data:image/png;base64,' + imgRecente"
                  id="vitrine"
                />
              </div>
            </div>
          </card>
        </div>

        <div class="col-md-6 mr-auto">
          <card class="card-register card-white">
            <modal-rec-facial :typePonto="2" />
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 mb-2 d-flex back-button">
          <base-button type="primary" size="sm" @click="showRecFacial = false">
            <i class="tim-icons icon-minimal-left"></i> Voltar
          </base-button>
        </div>
      </div>
    </div>
    <Carregando v-if="isLoading" />

    <modal :show.sync="postos.length > 0">
      <template slot="header">
        <h4 class="modal-title" id="exampleModalLabel">
          Clique no <b>POSTO DE TRABALHO</b> que deseja Registrar seu Ponto
        </h4>
      </template>
      <div class="row" style="max-height: 300px; overflow: auto;">
        <div
          class="col-12 d-flex justify-content-evenly"
          v-for="item in postos"
          :key="item.DS_LOCAL"
          @click="selecionarPosto(item)"
        >
          <card class="text-center car pt-4 pb-0">
            <h3>
              {{ item.DS_LOCAL ? item.DS_LOCAL : item.NM_FANTASIA_EMPREGADOR }}
            </h3>
          </card>
        </div>
      </div>
      <template slot="footer">
        <base-button type="danger" @click="postos = []">Fechar</base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import {
  BaseCheckbox,
  Card,
  BaseInput,
  BasePagination,
} from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import Carregando from "../../src/pages/Loads/Carregando.vue";
// import users from "../../../pages/Tables/users.js";
import Fuse from "fuse.js";
// import Fuse from "fuse.js";
import ModalRecFacial from "./Components/ModalRecFacial.vue";
import Modal from "@/components/Modal.vue";
import swal from "sweetalert2";

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BaseCheckbox,
    Carregando,
    Card,
    BaseInput,
    BasePagination,
    ModalRecFacial,
    Modal,
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },

  data() {
    return {
      postos: [],
      isLoading: false,
      selectRow: [],
      showRecFacial: false,
      imgRecente: "",
      pagination: {
        perPage: 100,
        currentPage: 1,
        perPageOptions: [50, 100, 150, 200],
        total: 0,
      },
      dialogHorarioLimite: false,
      searchQuery: "",
      propsToSearch: ["nome"],
      tableColumns: [
        {
          prop: "nome",
          label: "Funcionário",
          minWidth: 200,
        },
      ],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      dados: "",
    };
  },

  created() {
    this.carregarDados();
  },

  mounted() {
    this.listarFuncionarios();
    setTimeout(() => {
      this.$refs.focusMe.focus();
    }, 1000);
  },

  methods: {
    carregarDados() {
      this.dados = JSON.parse(this.$session.get("dados"));
    },
    itemSelecionado() {
      this.showRecFacial = true;
    },

    carregarFuse() {
      this.fuseSearch = new Fuse(this.tableData, {
        keys: ["nome"],
        threshold: 0.3,
      });
    },

    carregarFotoF(cpf) {
      let th = this;
      let jsonn = new FormData();
      jsonn.append("nrCpf", cpf);

      this.axios
        .post(
          `${process.env.VUE_APP_API_ADDRESS_REC_FACIAL}/getFotoRecente`,
          jsonn
        )
        .then((response) => {
          th.imgRecente = response.data.ImagemRecente;
        })
        .finally(() => {})
        .catch(() => {});
    },

    handleRecFacial(row) {
      this.selectRow = row;
      this.postos = [];
      this.carregarPostos(row.cpf);
    },

    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },

    carregarPostos(cpf) {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        cpf_empregado: cpf,
      };
      this.axios
        .post("/api/login/loginEmpregadoApenasCpf", bodyFormData)
        .then((response) => {
          th.isLoading = false;

          if (response.data.data.dados.length == 1) {
            const dados = response.data.data.dados[0];
            th.$session.set(
              "facial",
              JSON.stringify({
                cpf: dados.CPF_EMPREGADO,
                idEmpregado: dados.ID_EMPREGADO,
                idEmpregador: dados.ID_EMPREGADOR,
                FUSO: dados.FUSO,
                tipo_batida: dados.TIPO_BATIDA,
                matricula: dados.matricula,
                matricula2: dados.matricula2,
              })
            );

            th.showRecFacial = true;
            th.carregarFotoF(cpf);
            setTimeout(() => {
              location.reload();
            }, 60000);
          } else if (response.data.data.dados.length > 1) {
            this.postos = response.data.data.dados;
          } else {
            th.showSwal(
              "auto-close",
              "Erro",
              "Nenhum posto de trabalho encontrado",
              "error"
            );
          }
        })
        .catch((err) => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Nenhum posto de trabalho encontrado",
            "error"
          );
        });
    },

    selecionarPosto(dados) {
      this.postos = [];
      this.$session.set(
        "facial",
        JSON.stringify({
          cpf: dados.CPF_EMPREGADO,
          idEmpregado: dados.ID_EMPREGADO,
          idEmpregador: dados.ID_EMPREGADOR,
          FUSO: dados.FUSO,
          tipo_batida: dados.TIPO_BATIDA
        })
      );

      this.showRecFacial = true;
      this.carregarFotoF(dados.CPF_EMPREGADO);
      setTimeout(() => {
        location.reload();
      }, 60000);
    },

    listarFuncionarios() {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.dados.db_name,
      };
      this.axios
        .post("/api/empregado/listarEmpregados2", bodyFormData)
        .then((response) => {
          th.isLoading = false;
          th.tableData = response.data.data.dados;
          th.carregarFuse();
        })
        .catch((err) => {
          th.isLoading = false;
        });
    },

    async register() {
      let isValidForm = await this.$validator.validateAll();
      if (isValidForm) {
        // TIP use this.model to send it to api and perform register call
      }
    },
  },

  watch: {
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>
<style>
.car {
  cursor: pointer;
  width: 300px;
  transition: transform 0.5s;
}

.car:hover {
  background: #f3f3f3;
  transform: scale(1.1);
  -webkit-box-shadow: 0px 5px 10px -5px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 5px 10px -5px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 5px 10px -5px rgba(0, 0, 0, 0.75);
  transition: transform 0.2s;
}

.car:active {
  transform: scale(1);
  -webkit-box-shadow: 0px 5px 5px -5px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 5px 5px -5px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 5px 5px -5px rgba(0, 0, 0, 0.75);
}
.back-button {
  justify-content: flex-start;
}

@media screen and (max-width: 768px){
  .back-button {
    justify-content: center;
  }
}

.el-table table tr:hover {
    background-color: #fff999 !important;
}

</style>
